import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { BackgroundDecoration } from './components/BackgroundDecoration';
export function App() {
  return <div className="relative bg-stone-50 min-h-screen w-full overflow-x-hidden font-[sans-serif] font-light" data-id="element-0">
      <BackgroundDecoration data-id="element-1" />
      <Header data-id="element-2" />
      <main className="relative z-10" data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Skills data-id="element-6" />
        <Projects data-id="element-7" />
        <Contact data-id="element-8" />
      </main>
    </div>;
}